export { MdsIcon } from "./MdsIcon";
export type { MdsIconProps } from "./MdsIcon";
